const tabs = [
  {
    id: 'open',
    name: 'セール',
    title: '募集中一覧'
  },
  {
    id: 'history',
    name: 'エントリー履歴',
    title: 'エントリー履歴'
  },
  {
    id: 'closed',
    name: '募集終了',
    title: '募集終了'
  }
]

export default tabs



// WEBPACK FOOTER //
// ./src/common/sale-tabs.js